import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import CadsAIAssignedUIProvider from './CadsAIUIProvider';
import { Col, Container, FormGroup, Input, Row } from 'reactstrap';
import { findDataInArray } from '@/shared/helpers';
import { setSelectedAssignProduct } from '@/containers/Control-Panel/redux/actions';
import { setUserState } from '@/containers/Control-Panel/redux/user/actions';
import * as Constants from '@/shared/helpers/constants';
import { CADS_AI_PRODUCTS } from '@/shared/helpers/constants';
import { isEmpty } from 'lodash/lang';
import { setActiveTab } from '@/containers/Control-Panel/Assigned/redux/actions';
import { paths } from '@/shared/helpers/paths';
import { useHistory } from 'react-router';
import AssignedLPTabs from '@/containers/Cads-AI/ManageLearning/Assigned/components/learningPath/AssignedLearningPathTabs';
import AssignedCourseTabs from '@/containers/Cads-AI/ManageLearning/Assigned/components/course/AssignedCourseTabs';
import { setCohortState } from '@/containers/Control-Panel/redux/cohort/actions';
import { setOrgState } from '@/containers/Control-Panel/redux/organization/actions';
import { defaultUserState } from '@/containers/Control-Panel/redux/user/reducer';
import { defaultCohortState } from '@/containers/Control-Panel/redux/cohort/reducer';
import { defaultOrgState } from '@/containers/Control-Panel/redux/organization/reducer';

const { COURSE, LEARNING_PATH } = CADS_AI_PRODUCTS;
const { COHORT, ORGANIZATION, USERS } = Constants;
const productList = [LEARNING_PATH, COURSE];
const cadsAIAssignedBaseUrl = paths.CADS_AI.LEARNING.ASSIGNED;

const AssignedPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const { checkedItemIds } = useSelector((state) => state.assignedPage, shallowEqual);
  const { activeTab } = useSelector((state) => state.assignedPage, shallowEqual);
  const { assignedOrgId, assignedProduct } = useSelector((state) => state.cadsAI, shallowEqual);
  const [selectedProduct, setSelectedProduct] = React.useState(assignedProduct);

  React.useEffect(() => {
    const activeTabParam = new URLSearchParams(location.search)?.get('activeTab');
    const assignedProductId = new URLSearchParams(location.search)?.get('assignmentFor');
    if (
      activeTabParam &&
      activeTabParam !== activeTab &&
      [USERS, COHORT, ORGANIZATION].includes(activeTab)
    ) {
      dispatch(setActiveTab(activeTab));
    }
    if (assignedProductId) {
      const productIdx = productList.findIndex((product) => product.id === +assignedProductId);
      if (productIdx !== -1 && productList[productIdx] !== selectedProduct)
        dispatch(setSelectedAssignProduct(productList[productIdx]));
    }
  }, [location.search]);

  const assignedUIEvents = {
    openUnassignDialog: () => {
      history.push(`${cadsAIAssignedBaseUrl}/confirm-unassign`);
    },
  };

  const handleChange = ({ target: { value } }) => {
    const productId = +value;
    setSelectedProduct(productList.find((product) => product.id === productId));
    const product = findDataInArray(productList, productId, 'id');
    dispatch(setSelectedAssignProduct(product));
    if ([LEARNING_PATH.id, COURSE.id].includes(productId)) {
      const filters = { assigned: true, feature: productId };
      switch (activeTab) {
        case USERS:
          return dispatch(
            setUserState({
              ...defaultUserState,
              ...filters,
              searchAssigned: { ...defaultUserState.searchAssigned, orgId: assignedOrgId },
            }),
          );
        case COHORT:
          return dispatch(
            setCohortState({
              ...defaultCohortState,
              ...filters,
              searchAssigned: { ...defaultCohortState.searchAssigned, orgId: assignedOrgId },
            }),
          );
        case ORGANIZATION:
          return dispatch(setOrgState({ ...defaultOrgState, ...filters }));
        default:
          return false;
      }
    }
  };

  return (
    <CadsAIAssignedUIProvider assignedUIEvents={assignedUIEvents}>
      <Switch>
        <Route path={`${cadsAIAssignedBaseUrl}/confirm-unassign`}>
          {({ history, match }) => {
            if (isEmpty(checkedItemIds)) history.push(cadsAIAssignedBaseUrl);
          }}
        </Route>
      </Switch>

      <Col md={12} lg={12}>
        <Container>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Row>
                  <Col sm={9}>
                    <h3 className="page-title">{selectedProduct.name}</h3>
                    <h3 className="page-subhead subhead">
                      From here you can manage the unassignment for{' '}
                      {selectedProduct.name?.toLowerCase()}.
                    </h3>
                  </Col>
                  <Col sm={3}>
                    Unassignment For
                    <Input
                      id="assignProductSelect"
                      name="select"
                      type="select"
                      value={selectedProduct.id}
                      onChange={handleChange}
                    >
                      {productList.map(({ id, name }) => (
                        <option key={id} value={id}>
                          {name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>
              </FormGroup>
            </Col>
            {LEARNING_PATH.id === selectedProduct.id && <AssignedLPTabs />}
            {COURSE.id === selectedProduct.id && <AssignedCourseTabs />}
          </Row>
        </Container>
      </Col>
    </CadsAIAssignedUIProvider>
  );
};

export default AssignedPage;
